module.exports = __webpack_public_path__ + "img/cattunnel17.ba1c0849.jpg";